
import React, { PropsWithChildren } from 'react'
import classnames from 'clsx'
import { UISizes, UI_SIZES } from 'components/utils/UiConfig'
import styled, { css } from 'styled-components'
import { rem } from 'polished'
import variables from 'styles/vendor/bootstrap/variables'

interface Props {
  className?: string;
  xxl?: number;
  xl?: number;
  lg?: number;
  md?: number;
  sm?: number;
  xs?: number;
}

const gridRange = () => Array(variables.gridColumns).fill(null).map((ignore, i) => i)

const responsiveColumns = css`
  ${gridRange().map(i => [
    `&.col-xs-${i + 1}`,
    `&.col-sm-${i + 1}`,
    `&.col-md-${i + 1}`,
    `&.col-lg-${i + 1}`,
    `&.col-xl-${i + 1}`,
  ].join(', \n'),
  ).join(', \n')}
`

const makeGrid = size => css`
  ${gridRange().map(i => `
    &.col-${size}-${i + 1} {
      width: ${Math.round((i + 1) / variables.gridColumns * 100)}%;
      float: left;
    }
  `).join('')}
`

const Column = styled.div`
  ${responsiveColumns} {
    position: relative;
    min-height: 1px;
    padding-right: ${rem(variables.gutterWidth / 2)};
    padding-left: ${rem(variables.gutterWidth / 2)};
  }

  ${makeGrid('xs')}

  @media (min-width: ${variables.screenSmMin}) {
    ${makeGrid('sm')}
  }

  @media (min-width: ${variables.screenMdMin}) {
    ${makeGrid('md')}
  }

  @media (min-width: ${variables.screenLgMin}) {
    ${makeGrid('lg')}
  }
`

function Col(props: PropsWithChildren<Props>) {
  const classes = UI_SIZES.reduce((acc: string[], size: UISizes) => {
    if (props[size]) {
      acc.push(`col-${size}-${props[size]}`)
    }
    return acc
  }, [])

  return (
    <Column
      className={classnames(props.className, classes)}>
      {props.children}
    </Column>
  )
}

export default Col
